module.exports = __webpack_public_path__ + "img/Line.48d2e670.svg";